import { Component, Injector, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule, MaterialModule, PageKind, UiModeType, } from 'jk-service';
import { AdvComModule, jkSingleComponent } from "jk-advcom";
import { UtysbService, templateUrlConfigUty } from '../_service_uty';
import { UtysbEditComponent, } from '../_edit_uty';


@Component({
  selector: 'app-utypi03',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    //Utypi03DetailComponent,
    //UtysbEditComponent,
    //UtysbTabEditComponent,
  ],
  templateUrl: './utypi03Pkg.component.html',//templateUrlConfigUty.utypi03,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi03Component extends jkSingleComponent implements OnInit {
  override _programId = 'utypi03';
  constructor() {
    //const injector = inject(Injector);

    super();
    this.srv = new UtysbService();
    this.uiMode = UiModeType.dialog;
    this.title = '萬用查詢建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'MAINTABLE', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };
    this.qbeConfig.addField = 'PS,TITLE';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = UtysbEditComponent;


    // this.constructorInit();
  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    this.srv.cdr = this.cdr;
  };




}
